import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormContext } from "../context/FormContext"; // Importar el contexto
import { getConvenios, getDocumentTypes, getDynamicIds, capitalizeWords} from "./getData";

const DatosPersonales = ({ onVolver, onDatosPersonalesSeleccionado }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const { formData, updateFormData } = useContext(FormContext); // Usar el contexto
  const [tooltip, setTooltip] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  ///////////////////////////////////////
  const { paisId, cadenaId } = getDynamicIds(); // Obtener el ID de la tienda especifica
  const [documentTypes, setDocumentTypes] = useState([]); // los tipos de documento por pais
  const [selectedDocType, setSelectedDocType] = useState(""); // Estado para el tipo de documento
  const [dniInput, setdniInput] = useState(""); // Estado para el DNI
  const [dniError, setDniError] = useState(false); // Estado para errores en el documento
  const [tpo_codigo, setTpo_codigo] = useState(""); // Estado para el codigo de documento
  const [tpo_maxLength, set_maxLength] = useState(""); // Estado para el maxLength
  const [cadenaUrl, setcadenaUrl] = useState(""); // Estado para la URL de la cadena
  ///////////////////////////////////////

  // Objeto con las URLs personalizadas para cada cadena


  // Estado para los convenios
  const [convenios, setConvenios] = useState([]);

  // Obtener los convenios desde la API
  useEffect(() => {
    // Datos del contexto en el componente de datos personales
    // console.log("form data datos personales", formData);
    const fetchConvenios = async () => {
      try {
        const response = await getConvenios();
        if (response?.success && Array.isArray(response.data)) {
          setConvenios(response.data);
        } else {
          setConvenios([]);
        }
      } catch (error) {
        // Error al obtener convenios desde la API
        console.error("Error obteniendo convenios:", error);
        setConvenios([]);
      }
    };

    fetchConvenios();

    if (formData.DatosPersonales) {
      const datos = formData.DatosPersonales;
      setValue("nombre", datos.int_pnombre);
      setValue("snombre", datos.int_snombre);
      setValue("apellido", datos.int_apaterno);
      setValue("sapellido", datos.int_amaterno);
      setValue("fechanacimiento", new Date(datos.fechanacimiento));
      setValue("correo", datos.int_email);
      setValue("numerotelefono", datos.int_telefono);
      setValue("domicilio", datos.int_domicilio);
      setValue("dni", datos.int_nrodocidentidad);
      setValue("convenio", datos.cnv_codigo);
      setValue("tpo_codigo", datos?.tpo_codigo);
      setdniInput(datos.int_nrodocidentidad);
    }
  }, [formData, setValue]);

  useEffect(() => {
    if (paisId) {
      // ID de país para obtener tipos de documento
      // console.log("ID Tienda", paisId);
      getDocumentTypes(paisId)
        .then((docs) => {
          // Tipos de documento obtenidos para el país
          // console.log("Documentos", docs);
          setDocumentTypes(docs);
        })
        .catch((err) => {
          // Error al obtener tipos de documento
          console.error("Error obteniendo tipos de documento:", err);
          setDocumentTypes([]);
        });
    }
  }, [paisId]);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const onSubmit = (data) => {
    // Datos del formulario de datos personales enviados
    // console.log("DATA QUE SACA DE ALGUN LADO", data);
    if (!selectedDocType) {
      setDniError(true);
      return; // Detén el flujo si no se seleccionó un tipo de documento
    }

    if (
      selectedDocType &&
      (dniInput.length < 5 || dniInput.length > tpo_maxLength)
    ) {
      setDniError(true);
      setShowTooltip(true);
      return;
    }

    const selectedConvenio = convenios.find(
      (convenio) => convenio.cnv_codigo === data.convenio
    );
    const convenioDescripcion = selectedConvenio
      ? selectedConvenio.cnv_descripcion
      : "";

    // Formatear la fecha antes de guardarla
    const formattedDate = formatDate(new Date(data.fechanacimiento));
    const datosPersonales = {
      int_pnombre: data.nombre,
      int_snombre: data.snombre,
      int_apaterno: data.apellido,
      int_amaterno: data.sapellido,
      fechanacimiento: formattedDate,
      int_email: data.correo,
      int_telefono: data.numerotelefono,
      int_domicilio: "los conquistadores 1700",
      int_usodatopersonal: true,
      int_usoadicional: true,
      int_optin: false,
      tipo_documento: selectedDocType,
      cnv_codigo: data.convenio, // Aquí se guarda el cnv_codigo seleccionado
      nombre_convenio: convenioDescripcion,
    };

    if (tpo_codigo && dniInput) {
      datosPersonales.tpo_codigo = tpo_codigo;
      datosPersonales.int_nrodocidentidad = dniInput;
      setDniError(false);
    }else{
      datosPersonales.tpo_codigo = null;
      datosPersonales.int_nrodocidentidad = null;
      setDniError(true);
    }

    if (!data.convenio){
      datosPersonales.cnv_codigo = 0;
      datosPersonales.nombre_convenio = "Sin convenio";
    }

    // Datos personales procesados para enviar al contexto
    // console.log("Campos enviados al resumen", datosPersonales);
    updateFormData({ DatosPersonales: datosPersonales });
    onDatosPersonalesSeleccionado();
  };

  //LOGICA LINKS DINAMICOS 

  const urlsPorCadena = {
    eco: "https://www.econopticas.cl/convenios",
    gmo: {
      2: "https://www.gmo.cl/seguros-y-convenios",
      3: "https://gmo.com.co/convenios",
    },
    opv: "https://www.opv.cl/institucional#convenios",
  };

  useEffect(() => {
    // Determinar la URL correspondiente a la cadena
    if (formData?.cadena === "gmo" && paisId === 2 || paisId === 3) {
      setcadenaUrl(urlsPorCadena[formData?.cadena][paisId] || null);
    }else{
      setcadenaUrl(urlsPorCadena[formData?.cadena] || null);
    }
  }, [formData?.cadena, paisId]);

  return (
    <div
    className={`col-md-6 pads0-768
       ${formData?.cadena === "eco" ? "eco-theme" : ""}
       ${formData?.cadena === "gmo" ? "gmo-theme" : ""}
    `}
     id="patient-info">
      <div className="row patient-info-container">
        <div className="col12 pads0">
          <form onSubmit={handleSubmit(onSubmit)} className="form-add-patient">
            <div className="row mb40">
              <div className="col-12 text-center">
                <h3>¿Para quién es este examen?</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 mb20">
                <input
                  type="text"
                  className="patient-info-input patient-info-name"
                  id="nombre"
                  required
                  placeholder="Nombre"
                  {...register("nombre", {
                    required: "El nombre es obligatorio",
                  })}
                />
              </div>

              <div className="col-md-4 mb20">
                <input
                  type="text"
                  className="patient-info-input patient-info-name"
                  id="snombre"
                  placeholder="Segundo nombre"
                  {...register("snombre")}
                />
              </div>

              <div className="col-md-4 mb20">
                <input
                  type="text"
                  className="patient-info-input patient-info-last"
                  id="apellido"
                  required
                  placeholder="Apellido"
                  {...register("apellido", {
                    required: "El apellido es obligatorio",
                  })}
                />
              </div>

              <div className="col-md-4 mb20">
                <input
                  type="text"
                  className="patient-info-input patient-info-last"
                  id="sapellido"
                 
                  placeholder="Segundo Apellido"
                  {...register("sapellido")}
                />
              </div>

              <div className="col-md-4 mb20">
                <input
                  type="date"
                  className="patient-info-input patient-info-birth"
                  id="fechanacimiento"
                  required
                  max="2020-12-31"
                  {...register("fechanacimiento", {
                    required: "La fecha de nacimiento es obligatoria",
                  })}
                />
              </div>

              <div className="col-md-4 mb20">
                <input
                  className="patient-info-input patient-info-mail"
                  type="email"
                  required
                  id="correo"
                  placeholder="Correo Electrónico"
                  {...register("correo", {
                    required: "El correo electrónico es obligatorio",
                  })}
                />
              </div>

              <div className="col-md-4 mb20">
                <input
                  className="patient-info-input patient-info-phone"
                  type="text"
                  required
                  id="numerotelefono"
                  placeholder="Teléfono de Contacto"
                  {...register("numerotelefono", {
                    required: "El teléfono es obligatorio",
                  })}
                />
              </div>
              
              {(paisId === 2 || paisId === 3) && (
                <div className="col-md-4 mb20">
                <select
                  className="patient-info-input patient-info-conv"
                  id="convenio"
                  {...register("convenio", {
                    required: "Por favor selecciona un convenio válido",
                  })}
                  defaultValue=""
                >
                  <option value="" disabled hidden>
                    Previsión de salud
                  </option>
                  {convenios.map((convenio) => (
                    <option
                      key={convenio.cnv_codigo}
                      value={convenio.cnv_codigo}
                    >
                      {convenio.cnv_descripcion}
                    </option>
                  ))}
                </select>
              </div>
              )}
              

              <div className="col-md-4 mb20">
                <select
                  className="patient-info-input"
                  value={selectedDocType} // Conecta al estado controlado
                  required
                  onChange={(e) => {
                    const value = e.target.value; // Captura el valor seleccionado
                    setSelectedDocType(value); // Actualiza el estado
                    const selectedOption = e.target.options[e.target.selectedIndex];
                    const code = selectedOption.getAttribute('data-code');
                    setTpo_codigo(code);
                    const maxLength = selectedOption.getAttribute('data-maxLength');
                    set_maxLength(maxLength);
                    setDniError(false); // Resetea errores si los hubiera
                  }}
                >
                  <option value="" disabled hidden>
                    Tipo de documento
                  </option>
                  {documentTypes.map((docType) => (
                    <option key={docType.tpo_codigo} data-code={docType.tpo_descripcion.tpo_codigo} value={capitalizeWords(docType.tpo_descripcion.tpo_descripcion)} data-maxLength={docType.tpo_descripcion.tpo_longitud}>
                      {capitalizeWords(docType.tpo_descripcion.tpo_descripcion)}
                    </option>
                  ))}
                </select>
              </div>
              
              {selectedDocType && (
                <div className="col-md-4 mb20">
                  <input
                    type="text"
                    className="patient-info-input"
                    placeholder={selectedDocType}
                    value={dniInput}
                    maxLength={tpo_maxLength}
                    onChange={(e) => setdniInput(e.target.value)}
                    required
                  />
                  {dniError ? (
                    <p className="error-message-alert">
                      El {selectedDocType} ingresado no es válido
                    </p>
                  ) : (
                    <span className="informacion-rut">Ingrese su {selectedDocType}</span>
                  )}
                </div>
              )}
              {(paisId === 2 || paisId === 3 && cadenaId === 1) && (
                <div className="col-12 text-md-start text-center mt40">
                  <p className="mb0 info-conv">
                    *Descuentos válidos en armazones, cristales, anteojos de sol y
                    lentes de contacto según convenio. Se excluye lentes de
                    contacto desechables, consultas de tecnólogo médico y/o
                    contactólogo, líquidos y/o accesorios. Promoción no acumulable
                    con otras ofertas, convenios o ventas especiales. Disponible
                    solo en tiendas físicas, mayor información de cada Convenio
                    disponible en
                    {cadenaUrl ? (
                      <a
                        href={cadenaUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        {cadenaUrl}
                      </a>
                    ) : (
                      ""
                    )}
                  </p>
                </div>
              )}

              <div className="col-12 text-end mt20">
                <input
                  type="submit"
                  className="step-patient-button"
                  value={"CONTINUAR"}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DatosPersonales;
